import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {
  authForm!: FormGroup;
  otpForm!: FormGroup;
  
  step: 1 | 2 = 1;
  isLoginMode: boolean = false;
  isLoading: boolean = false;
  currentEmail: string = '';
  currentYear: number = new Date().getFullYear();

  constructor(
    private fb: FormBuilder,
    private apiService: ApiService,
    private router: Router,
    private cookie: CookieService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.authForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]]
    });

    // Create 6 individual form controls for the OTP boxes
    this.otpForm = this.fb.group({
      d1: ['', [Validators.required, Validators.pattern('[0-9a-zA-Z]')]],
      d2: ['', [Validators.required, Validators.pattern('[0-9a-zA-Z]')]],
      d3: ['', [Validators.required, Validators.pattern('[0-9a-zA-Z]')]],
      d4: ['', [Validators.required, Validators.pattern('[0-9a-zA-Z]')]],
      d5: ['', [Validators.required, Validators.pattern('[0-9a-zA-Z]')]],
      d6: ['', [Validators.required, Validators.pattern('[0-9a-zA-Z]')]]
    });
  }

  // Auto-focus next input
  onOtpInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value && index < 6) {
      const nextInput = document.getElementById(`otp${index + 1}`);
      if (nextInput) nextInput.focus();
    }
  }

  // Handle backspace to focus previous input
  onOtpKeydown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace' && !(event.target as HTMLInputElement).value && index > 1) {
      const prevInput = document.getElementById(`otp${index - 1}`);
      if (prevInput) prevInput.focus();
    }
  }

  // Handle paste events to fill all boxes
  onOtpPaste(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text')?.trim();
    if (pastedData && pastedData.length === 6) {
      for (let i = 0; i < 6; i++) {
        this.otpForm.get(`d${i + 1}`)?.setValue(pastedData[i]);
      }
      document.getElementById('otp6')?.focus();
      event.preventDefault();
    }
  }

  toggleMode(): void {
    this.isLoginMode = !this.isLoginMode;
    const nameControl = this.authForm.get('name');
    
    if (this.isLoginMode) {
      nameControl?.clearValidators();
      nameControl?.setValue('');
    } else {
      nameControl?.setValidators([Validators.required]);
    }
    nameControl?.updateValueAndValidity();
  }

  requestOtp(): void {
    if (this.authForm.invalid) return;

    this.isLoading = true;
    this.currentEmail = this.authForm.value.email.trim();

    const name = !this.isLoginMode ? this.authForm.value.name.trim() : undefined;

    this.apiService.requestOtp(this.currentEmail, name).subscribe({
      next: () => {
        this.isLoading = false;
        this.step = 2;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  verifyOtp(): void {
    if (this.otpForm.invalid) return;

    this.isLoading = true;
    const email = this.currentEmail;
    
    // Stitch the 6 boxes together
    const code = Object.values(this.otpForm.value).join('').toUpperCase();

    this.apiService.verifyOtp(email, code).subscribe({
      next: () => {
        this.commonService.initializeSession();
        this.router.navigate(['/techsure/assessments']);
      },
      error: () => {
        this.isLoading = false;
        // The interceptor will show the 401 error modal without redirecting
      }
    });
  }
}